import { useEffect } from "react";

export const formatPrice = (price) => {
  const hasDecimals = price % 1 !== 0;
  return new Intl.NumberFormat("sv-SE", {
    minimumFractionDigits: hasDecimals ? 2 : 0,
    maximumFractionDigits: 2,
  })
    .format(price)
    .replace(/\u00A0/g, " ");
};

export const formatPriceWithCurrency = (price) => {
  if (price === null || price === undefined) {
    return "0";
  }

  return `${formatPrice(price)} kr`;
};

export const formatNumber = (number) => {
  const parsedNumber = parseFloat(number);
  if (!parsedNumber) {
    return "0";
  }

  return new Intl.NumberFormat("sv-SE").format(parsedNumber);
};

const isBrowser = typeof window !== "undefined";

export const getStorageItem = (key) => {
  if (!isBrowser) {
    return null;
  }

  try {
    return window.localStorage.getItem(key);
  } catch (error) {
    return null;
  }
};

export const setStorageItem = (key, value) => {
  if (!isBrowser) {
    return;
  }

  try {
    window.localStorage.setItem(key, value);
  } catch (error) {}
};


export const useModalCloseOnEsc=(isOpen, handleClose) =>{
  useEffect(()=>{
    const handleEscape = (event) =>{
      if (event.key == "Escape" && isOpen){
        handleClose();
      }
    };
    if (isOpen){
      document.addEventListener('keydown', handleEscape);
    }

    return () => {
      document.addEventListener('keydown', handleEscape);
    };
  }, [isOpen, handleClose]);
};